<template>
  <aw-spinner />
</template>
<script setup lang="ts">
  import { navigateTo, useNuxtApp, useRoute } from 'nuxt/app';
  import AwSpinner from '~~/common/components/Common/AwSpinner.vue';

  defineOptions({
    name: 'CetelemStatusBack',
  });

  const { $logger } = useNuxtApp();
  const route = useRoute();
  try {
    await navigateTo(`/cetelem/back?status=${route.params.status}&orderId=${route.params.order_ident}&dossierId=${route.query.dossierId ?? ''}&customerKey=${route.query.customerKey ?? ''}&purchaseAmount=${route.query.purchaseAmount ?? ''}`, { redirectCode: 302 });
  } catch (err) {
    $logger.error(err);
  }
</script>
